import { useHistory } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { ButtonGroup, Spinner, Form, InputGroup, Toast, Modal, OverlayTrigger, Tooltip, Tabs, Tab } from 'react-bootstrap';
import { Button, Card, CardBody, CardText, CardTitle, Row, Col } from 'reactstrap';
import { TriangleHalf, Arrow90degLeft, Arrow90degRight, Save2Fill, Backspace } from 'react-bootstrap-icons';
import Tables from './sorties/gridtables';
import ArticlesLivresRetournes from './sorties/indexArticles';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import Axios from 'axios';
import dateformat from 'dateformat';
import common from '../../commonData';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import NumberToLetter from '../../converter';
import AddSortie from './sorties/addSortie';
import FilterModal from './sorties/filterModal';
import Loader from 'views/layouts/Loader';
import IndexProforma from './factures/indexProforma';
import IndexFacture from './factures/indexFacture';
import IndexReglement from './reglements/indexReglement';
import IndexAvoir from './factures/indexAvoir';

var dta = [];
function Index() {
    const history = useHistory();
    const [datal, setDatal] = useState([]);
    const [datas, setDatas] = useState([]);
    const [client, setClient] = useState([]);
    const [datasProf, setDatasProf] = useState([]);
    const [avoirData, setAvoirDatas] = useState([]);
    const [datasFact, setDataFact] = useState([]);
    const [articleDatas, setArticleDatas] = useState([]);
    const [dataReglement, setReglementDatas] = useState([]);
    const [load, setLoad] = useState(false);
    const [isLoading, setIsLoad] = useState(false);
    const [msg, setMsg] = useState('');
    const [isSave, setIsSave] = useState(false);
    const [clientNom, setClientNom] = useState('');
    const [idsort, setId] = useState(0);
    const [msgGravity, setMsgravity] = useState('info');
    const [show, setShow] = useState(false);
    const [showretour, setShowRetour] = useState(false);
    const [idlignretour, setIdLignRetour] = useState(0);
    const [annulretour, setAnnulRetour] = useState(0);
    const [qte, setQte] = useState(0);
    const [typeModal, setTypeModal] = useState(0);
    const [showAdd, setShowAdd] = useState(false);
    const [showDetailFactureModal, setShowDetailFactureModal] = useState(false);
    const [factureDetail, setfactureDetail] = useState({});
    const [actualise, setActualise] = useState(false);
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [paramShow, setParamShow] = useState(false);
    const [key, setKey] = useState('sortie');
    var ladate = new Date();
    const [state, setState] = useState({
        demandeur: '',
        engin: '',
        nobon: '',
        datesort: dateformat(ladate.getMonth() + 1 + '/' + ladate.getDate() + '/' + ladate.getFullYear(), 'yyyy-mm-dd'),
        client_id: null,
        lignesort: [],
        type_remise: '0',
        remise_main: 0,
        sitva: '0'
    });

    useEffect(() => {
        if (localStorage.getItem('user-info')) {
            (async function anyNameFunction() {
                switch (key) {
                    case 'sortie':
                        await getSortie();
                        break;
                    case 'article':
                        await getSortieretourne();
                        break;
                    case 'facture':
                        await getFacture();
                        break;
                    case 'proforma':
                        await getProforma();
                        break;
                    case 'avoir':
                        await getFactureAvoir();
                        break;
                    default:
                        await getReglement();
                        break;
                }
            })();
        } else {
            history.push('/login');
        }
    }, [actualise, history, key]);

    async function getSortie() {
        const log = common.search(common.userdroit, 'SAD');
        const log1 = common.search(common.userdroit, 'SOR');
        if (log === undefined) {
            if (log1 === undefined) {
                return;
            }
        }
        setLoad(true);
        setIsLoad(true);
        await Axios.get(common.ipapi + '/api/client/clientunique', common.tok)
            .then((response) => {
                setClient(response.data);
            })
            .catch((errors) => {});

        let url = common.userclientid
            ? common.ipapi + '/api/sortie/indexbyclient/' + common.userclientid
            : common.ipapi + '/api/sortie/index/' + common.societe;
        await Axios.get(url, common.tok)
            .then((response) => {
                dta = response.data.datas;
                setDatas(response.data.datas);
                setLoad(false);
                setIsLoad(false);
            })
            .catch((errors) => {
                setLoad(false);
                setIsLoad(false);
            });
    }

    //---------- LES ARTICLES LIVRES ET RETOURNES (lignes de sortie à plat) ----------
    async function getSortieretourne() {
        const log = common.search(common.userdroit, 'SAD');
        const log1 = common.search(common.userdroit, 'SOR');
        if (log === undefined) {
            if (log1 === undefined) {
                return;
            }
        }
        setLoad(true);
        setIsLoad(true);
        try {
            const url = common.ipapi + '/api/sortie/livresretournes/' + common.societe;
            const response = await Axios.get(url, common.tok);
            setArticleDatas(response.data.datas || []);
        } catch (error) {
            console.error('Erreur lors de la récupération des articles livrés/retournés:', error);
            setArticleDatas([]);
            setMsg('Erreur lors de la récupération des articles livrés/retournés');
            setMsgravity('danger');
            setIsSave(true);
        } finally {
            setLoad(false);
            setIsLoad(false);
        }
    }

    async function getFacture() {
        const log = common.search(common.userdroit, 'SAD');
        const log1 = common.search(common.userdroit, 'FAC');
        if (log === undefined) {
            if (log1 === undefined) {
                return;
            }
        }
        setLoad(true);
        setIsLoad(true);
        try {
            const url = common.ipapi + '/api/facture/index/' + common.societe;
            const response = await fetch(url, common.tok);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const json = await response.json();
            if (!json.datas) {
                setLoad(false);
                setIsLoad(false);
                console.warn('Aucune donnée trouvée dans la réponse.');
                setDataFact([]);
                return;
            }
            setDataFact(json.datas.data);
        } catch (error) {
            setLoad(false);
            setIsLoad(false);
            console.error('Erreur de récupération des données:', error);
        } finally {
            setLoad(false);
            setIsLoad(false);
        }
    }
    async function getProforma() {
        const log = common.search(common.userdroit, 'SAD');
        const log1 = common.search(common.userdroit, 'FAC');
        if (log === undefined) {
            if (log1 === undefined) {
                return;
            }
        }
        setLoad(true);
        setIsLoad(true);
        try {
            const url = common.ipapi + '/api/facturepro/index/' + common.societe;
            const response = await fetch(url, common.tok);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const json = await response.json();
            if (!json.datas) {
                setLoad(false);
                setIsLoad(false);
                console.warn('Aucune donnée trouvée dans la réponse.');
                setDatasProf([]);
                return;
            }

            setDatasProf(json.datas);
        } catch (error) {
            setLoad(false);
            setIsLoad(false);
            console.error('Erreur de récupération des données:', error);
        } finally {
            setLoad(false);
            setIsLoad(false);
        }
    }
    async function getFactureAvoir() {
        const log = common.search(common.userdroit, 'SAD');
        const log1 = common.search(common.userdroit, 'FAC');
        if (log === undefined) {
            if (log1 === undefined) {
                return;
            }
        }
        setLoad(true);
        setIsLoad(true);
        await Axios.get(common.ipapi + '/api/avoir/index/' + common.societe, common.tok)
            .then((response) => {
                setAvoirDatas(response.data.datas);
                setLoad(false);
                setIsLoad(false);
            })
            .catch((errors) => {
                setLoad(false);
                setIsLoad(false);
            });
    }

    async function getReglement() {
        const log = common.search(common.userdroit, 'SAD');
        const log1 = common.search(common.userdroit, 'REG');
        if (log === undefined) {
            if (log1 === undefined) {
                return;
            }
        }
        setLoad(true);
        setIsLoad(true);
        await Axios.get(common.ipapi + '/api/reglement/index/' + common.societe, common.tok)
            .then((response) => {
                setReglementDatas(response.data.datas.data);
                setLoad(false);
                setIsLoad(false);
            })
            .catch((errors) => {
                setLoad(false);
                setIsLoad(false);
            });
    }

    function setShowFilterModals(param) {
        setShowFilterModal(true);
        setParamShow(param);
    }
    function onDelete(id) {
        const log = common.search(common.userdroit, 'SAD');
        const log1 = common.search(common.userdroit, 'SSOR');
        if (log === undefined) {
            if (log1 === undefined) {
                setMsg("Vous n'avez pas le droit d'effectuer cette action, merci de contacter l'administrateur");
                setMsgravity('danger');
                setIsSave(true);
                return;
            }
        }
        if (window.confirm("Voulez-vous supprimer cette sortie d'article ?")) {
            setLoad(true);
            Axios.delete(common.ipapi + '/api/sortie/destroy/' + id).then((response) => {
                if (response.data.status) {
                    const del = dta.filter((d) => d.id !== id);
                    dta = del;
                    setDatas(del);
                    setMsg(response.data.msg);
                    setMsgravity('info');
                    setIsSave(true);
                    setLoad(false);
                } else {
                    setMsg(response.data.msg);
                    setIsSave(true);
                    setLoad(false);
                    setMsgravity('danger');
                }
            });
        }
    }
    const retours = (d, bool) => {
        setShowRetour(true);
        setIdLignRetour(d.id);
        setAnnulRetour(bool);
        switch (bool) {
            case 1:
                setQte(d.quantite);
                break;

            default:
                setQte(d.quantiteretour);
                break;
        }
    };
    function retour() {
        if (window.confirm('Voulez-vous retourner cet article ?')) {
            setLoad(true);
            var url;
            if (annulretour === 0) {
                url = common.ipapi + '/api/sortie/retouroff/' + idlignretour;
            } else {
                url = common.ipapi + '/api/sortie/retouron/' + idlignretour;
            }
            var formData = new FormData();
            formData.append('quantite', qte);
            Axios({
                url: url,
                method: 'POST',
                headers: {
                    'Content-Type': 'form-data'
                },
                data: formData
            }).then((response) => {
                if (response.data.status === 1) {
                    setMsg(response.data.msg);
                    setMsgravity('info');
                    setIsSave(true);
                    setShowRetour(false);
                    setLoad(false);
                } else {
                    setMsg(response.data.msg);
                    setIsSave(true);
                    setLoad(false);
                }
            });
        }
    }

    function viewSortie(ids, typeM) {
        setLoad(true);
        Axios.get(common.ipapi + '/api/sortie/edit/' + ids).then((response) => {
            setClientNom(response.data.datas.client ? response.data.datas.client.raisonsocial : 'Néant');
            setDatal(response.data.datas);
            setState({
                demandeur: response.data.datas.demand_par,
                engin: response.data.datas.engin,
                nobon: response.data.datas.numbon,
                datesort: response.data.datas.datesort ? dateformat(response.data.datas.datesort, 'yyyy-mm-dd') : '',
                client_id: response.data.datas.clients_id,
                type_remise: response.data.datas.type_remise,
                remise_main: response.data.datas.remise_main,
                sitva: response.data.datas.sitva,
                lignesort: response.data.datas.lignesort
            });
            setId(ids);
            setShow(true);
            setTypeModal(typeM);
            setLoad(false);
        });
    }

    function setAdds(val) {
        const log = common.search(common.userdroit, 'SAD');
        const log1 = common.search(common.userdroit, 'ADS');
        if (log === undefined) {
            if (log1 === undefined) {
                setMsg("Vous n'avez pas le droit d'effectuer cette action, merci de contacter l'administrateur");
                setMsgravity('danger');
                setIsSave(true);
                return;
            }
        }
        setState({
            demandeur: '',
            engin: '',
            nobon: '',
            datesort: dateformat(ladate.getMonth() + 1 + '/' + ladate.getDate() + '/' + ladate.getFullYear(), 'yyyy-mm-dd'),
            client_id: null,
            lignesort: [],
            type_remise: '0',
            remise_main: 0,
            sitva: '0'
        });
        setShowAdd(true);
        setId(0);
    }

    function setIds(id) {
        const log = common.search(common.userdroit, 'SAD');
        const log1 = common.search(common.userdroit, 'UPO');
        if (log === undefined) {
            if (log1 === undefined) {
                setMsg("Vous n'avez pas le droit d'effectuer cette action, merci de contacter l'administrateur");
                setMsgravity('danger');
                setIsSave(true);
                return;
            }
        }
        findSortieById(id);
    }

    function showFacture(data) {
        setfactureDetail(data);
        setShowDetailFactureModal(true);
    }

    async function findSortieById(id) {
        setLoad(true);

        var lignesort = [];
        await Axios.get(common.ipapi + '/api/sortie/edit/' + id)
            .then((responses) => {
                if (responses.data.status) {
                    lignesort = groupBy(responses.data.datas.lignesort);
                    setState({
                        demandeur: responses.data.datas.demand_par,
                        engin: responses.data.datas.engin,
                        nobon: responses.data.datas.numbon,
                        datesort: responses.data.datas.datesort ? dateformat(responses.data.datas.datesort, 'yyyy-mm-dd') : '',
                        client_id: responses.data.datas.clients_id,
                        type_client: responses.data.datas.client.type_client,
                        lignesort: lignesort,
                        type_remise: responses.data.datas.type_remise,
                        remise_main: responses.data.datas.remise_main,
                        sitva: responses.data.datas.sitva
                    });
                    setId(id);
                    setShowAdd(true);
                }
                setLoad(false);
            })
            .catch((errors) => {
                setLoad(false);
            });

        setLoad(false);
    }

    function groupBy(tableauObjets) {
        let t = [];
        setLoad(true);
        return tableauObjets.reduce(function (res, value, index) {
            t.push({
                id: value.pivot.id,
                article_id: value.pivot.article_id,
                qrbarre: value.qrbarre,
                quantite: value.pivot.quantite,
                descriptionart: value.pivot.descriptionart,
                prix: value.pivot.prix,
                prixachat: value.pivot.prix_achat,
                remise: value.pivot.remise
            });
            return t;
        }, {});
    }

    const handleClose = () => {
        setShow(false);
        setParamShow(1);
        setShowFilterModal(false);
        setShowDetailFactureModal(false);
    };
    function formatCurrency(value) {
        return new Intl.NumberFormat('de-DE').format(Math.round(value));
    }
    //------- IMPRIMER FACTURE -----------------
    function printBl(id) {
        let text =
            'Voulez-vous imprimer avec ou sans le prix ? \n Ok si vous voulez afficher le prix \n Annuler si vous ne voulez pas afficher le prix';
        let res = window.confirm(text);
        setLoad(true);
        var doc = new jsPDF();
        var width = doc.internal.pageSize.getWidth();
        const getEdit = Axios.get(common.ipapi + '/api/sortie/edit/' + id);
        Axios.all([getEdit])
            .then(
                Axios.spread((...responses) => {
                    const dataFactures = [];
                    var i = 0;
                    let mont = 0,
                        t = 0;
                    let remise;
                    let remisChange = false;
                    let valremise = 0;
                    var siremise = false;
                    var totalBrute = 0;
                    var montantRemise = 0;
                    var totalRemise = 0;
                    var prixparQte = 0;
                    //console.log(responses[0].data.datas.lignesort);

                    responses[0].data.datas.lignesort.forEach((row) => {
                        if (row.pivot.remise != 0) {
                            siremise = true;
                        }
                        if (responses[0].data.datas.lignesort[0].pivot.remise != row.pivot.remise) {
                            remisChange = true;
                        }
                        prixparQte = Math.round(row.pivot.prix * (row.pivot.quantite - row.pivot.quantiteretour));
                        valremise =
                            responses[0].data.datas.type_remise == 0 && responses[0].data.datas.remise_main
                                ? responses[0].data.datas.lignesort[0].pivot.remise + responses[0].data.datas.remise_main
                                : responses[0].data.datas.lignesort[0].pivot.remise;
                        i++;
                        t = prixparQte;
                        totalBrute += t;
                        montantRemise =
                            responses[0].data.datas.type_remise == 0 && responses[0].data.datas.remise_main
                                ? prixparQte * ((row.pivot.remise + responses[0].data.datas.remise_main) / 100)
                                : prixparQte * (row.pivot.remise / 100);

                        totalRemise += montantRemise;
                        res
                            ? dataFactures.push([
                                  { content: row.pivot.descriptionart || row.descriptionart },
                                  { content: row.pivot.quantite - row.pivot.quantiteretour },
                                  { content: row.pivot.prix },
                                  { content: Math.round(montantRemise) },
                                  { content: new Intl.NumberFormat('de-DE').format(Math.round(t - montantRemise)) }
                              ])
                            : dataFactures.push([
                                  { content: row.pivot.descriptionart || row.descriptionart },
                                  { content: row.pivot.quantite }
                              ]);
                    });
                    var montantRemiseGen =
                        responses[0].data.datas.remise_main > 0
                            ? responses[0].data.datas.type_remise == 0
                                ? 0
                                : responses[0].data.datas.remise_main
                            : 0;

                    common.societe === 0
                        ? doc.addImage(common.logo, 'png', 14, 10, 30, 30)
                        : doc.addImage(common.logo1, 'png', 14, 10, 30, 30);

                    doc.setFontSize(16);
                    // doc.text(
                    //     common.ipapi === 'https://192.168.8.109:81' || common.ipapi === 'https://api.tracky-entrepot.com'
                    //         ? 'CLUB AUTO'
                    //         : 'HR MOTORS',
                    //     90,
                    //     17
                    // );
                    doc.setFontSize(12);
                    doc.setFillColor(0, 0, 0);
                    doc.rect(65, 19, width - 80, 10, 'F');
                    doc.setTextColor(255, 255, 255);
                    doc.text('BON DE LIVRAISON CLIENT', 90, 26);
                    doc.setFontSize(10);
                    doc.setDrawColor(0);
                    doc.rect(14, 40, width / 2 - 30, 21);
                    doc.rect(width / 2 - 10, 40, 100, 21);
                    doc.setTextColor(0, 0, 0);
                    doc.text(
                        responses[0].data.datas.client ? 'Non : ' + responses[0].data.datas.client.raisonsocial : 'Nom :',
                        width / 2 - 9,
                        45
                    );
                    doc.text(
                        responses[0].data.datas.client ? 'Télephone : ' + responses[0].data.datas.client.telcli : 'Télephone :',
                        width / 2 - 9,
                        50
                    );
                    responses[0].data.datas.client
                        ? doc.text('Type client : ' + responses[0].data.datas.client.sisociete, width / 2 - 9, 55)
                        : doc.text('Type client: ', width / 2 - 9, 55);

                    doc.text('N° BL : ' + responses[0].data.datas.numbon, 15, 45);
                    doc.text('Date livraison : ' + dateformat(responses[0].data.datas.datesort, 'dd/mm/yyyy'), 15, 50);
                    doc.text('Engin : ' + responses[0].data.datas.engin, 15, 55);
                    if (responses[0].data.datas.remise_main > 0) {
                        siremise = true;
                    }
                    doc.autoTable({
                        styles: {
                            fillColor: [0, 0, 0],
                            textColor: [255, 255, 255],
                            cellPadding: 1.5,
                            halign: 'center'
                        },
                        columnStyles: {
                            0: {
                                halign: 'center',
                                fillColor: [255, 255, 255],
                                textColor: [0, 0, 0],
                                cellPadding: 0.75,
                                fontSize: 10
                            },
                            1: {
                                halign: 'left',
                                fillColor: [255, 255, 255],
                                textColor: [0, 0, 0],
                                cellPadding: 0.75,
                                fontSize: 10
                            },
                            2: {
                                halign: 'center',
                                fillColor: [255, 255, 255],
                                textColor: [0, 0, 0],
                                cellPadding: 0.75,
                                fontSize: 10
                            },
                            3: {
                                halign: 'center',
                                fillColor: [255, 255, 255],
                                textColor: [0, 0, 0],
                                cellPadding: 0.75,
                                fontSize: 10
                            },
                            4: {
                                halign: 'center',
                                fillColor: [255, 255, 255],
                                textColor: [0, 0, 0],
                                cellPadding: 0.75,
                                fontSize: 10
                            },
                            5: {
                                halign: 'center',
                                fillColor: [255, 255, 255],
                                textColor: [0, 0, 0],
                                cellPadding: 0.75,
                                fontSize: 10
                            }
                        },
                        theme: 'grid',
                        startY: 75,
                        margin: { bottom: 35 },
                        horizontalPageBreak: true,
                        head: res
                            ? siremise
                                ? remisChange
                                    ? [['Article', 'Quantité', 'Prix unit.', 'Remise(%)', 'Montant']]
                                    : [['Article', 'Quantité', 'Prix unit.', 'Remise(' + valremise + '%)', 'Montant']]
                                : [['Article', 'Quantité', 'Prix unit.', 'Remise', 'Montant']]
                            : [['Article', 'Quantité']],
                        //res ? [['Ordre', 'Article', 'Quantité']] : [['Ordre', 'Article', 'Quantité']],
                        body: dataFactures
                    });

                    if (responses[0].data.datas.remise_main > 0) {
                        siremise = true;
                        if (responses[0].data.datas.type_remise == 0) {
                            // doc.text('Remise ' + responses[0].data.datas.remise_main + '%', 15, doc.lastAutoTable.finalY + 4);
                        } else {
                            doc.text('Remise ' + responses[0].data.datas.remise_main + ' FCFA', 15, doc.lastAutoTable.finalY + 4);
                        }
                    }
                    if (res) {
                        doc.autoTable({
                            styles: {
                                fillColor: [255, 255, 255],
                                textColor: [0, 0, 0],
                                cellPadding: 0.8,
                                lineColor: [0, 0, 0],
                                halign: 'center'
                            },
                            columnStyles: siremise
                                ? {
                                      0: {
                                          halign: 'center',
                                          fillColor: [255, 255, 255],
                                          textColor: [0, 0, 0],
                                          cellPadding: 0.75,
                                          fontSize: 10
                                      },
                                      1: {
                                          halign: 'center',
                                          fillColor: [255, 255, 255],
                                          textColor: [0, 0, 0],
                                          cellPadding: 0.75,
                                          fontSize: 10
                                      },
                                      2: {
                                          halign: 'center',
                                          fillColor: [255, 255, 255],
                                          textColor: [0, 0, 0],
                                          cellPadding: 0.75,
                                          fontSize: 10
                                      },
                                      3: {
                                          halign: 'center',
                                          fillColor: [255, 255, 255],
                                          textColor: [0, 0, 0],
                                          cellPadding: 0.75,
                                          fontSize: 10
                                      },
                                      4: {
                                          halign: 'center',
                                          fillColor: [255, 255, 255],
                                          textColor: [0, 0, 0],
                                          cellPadding: 0.75,
                                          fontSize: 10
                                      }
                                  }
                                : {
                                      0: {
                                          halign: 'center',
                                          fillColor: [255, 255, 255],
                                          textColor: [0, 0, 0],
                                          cellPadding: 0.75,
                                          fontSize: 10
                                      },
                                      1: {
                                          halign: 'center',
                                          fillColor: [255, 255, 255],
                                          textColor: [0, 0, 0],
                                          cellPadding: 0.75,
                                          fontSize: 10
                                      },
                                      2: {
                                          halign: 'center',
                                          fillColor: [255, 255, 255],
                                          textColor: [0, 0, 0],
                                          cellPadding: 0.75,
                                          fontSize: 10
                                      }
                                  },
                            margin: { bottom: 40 },
                            theme: 'grid',
                            startY: doc.lastAutoTable.finalY + 9,
                            head: siremise
                                ? [
                                      [
                                          'TOTAL BRUT',
                                          'REMISE',
                                          'TOTAL NET',
                                          responses[0].data.datas.sitva == 1 ? 'TVA EXONERE (18%)' : 'TVA (18%)',
                                          'TOTAL TTC'
                                      ]
                                  ]
                                : [['TOTAL NET', responses[0].data.datas.sitva == 1 ? 'TVA  EXONERE (18%)' : 'TVA (18%)', 'TOTAL TTC']],
                            body: siremise
                                ? [
                                      [
                                          formatCurrency(totalBrute),
                                          formatCurrency(totalRemise + montantRemiseGen),
                                          formatCurrency(Math.round(totalBrute - totalRemise - montantRemiseGen)),
                                          formatCurrency(Math.round((totalBrute - totalRemise - montantRemiseGen) * 0.18)),
                                          formatCurrency(
                                              responses[0].data.datas.sitva == 1
                                                  ? Math.round(totalBrute - totalRemise - montantRemiseGen)
                                                  : Math.round(
                                                        totalBrute -
                                                            totalRemise -
                                                            montantRemiseGen +
                                                            (totalBrute - totalRemise - montantRemiseGen) * 0.18
                                                    )
                                          )
                                      ]
                                  ]
                                : [
                                      [
                                          formatCurrency(totalBrute),
                                          formatCurrency(Math.round(totalBrute * 0.18)),
                                          formatCurrency(
                                              Math.round(responses[0].data.datas.sitva == 1 ? totalBrute : totalBrute + totalBrute * 0.18)
                                          )
                                      ]
                                  ]
                        });
                    }
                    var finalY = doc.lastAutoTable.finalY;
                    if (finalY > 217) {
                        doc.addPage();
                    }
                    const pageCount = doc.internal.getNumberOfPages();
                    for (var u = 1; u <= pageCount; u++) {
                        doc.setPage(u);
                        doc.setFontSize(10);
                        doc.text('Page ' + String(u) + ' sur ' + String(pageCount), 210 - 18, 292, null, null, 'right');
                    }
                    if (res !== false) {
                        doc.text('Arrêté à la somme de:', 15, 228);
                        doc.setFontSize(8);
                        doc.text(
                            NumberToLetter(
                                Math.round(
                                    responses[0].data.datas.sitva == 1
                                        ? totalBrute - totalRemise
                                        : totalBrute - totalRemise + (totalBrute - totalRemise) * 0.18
                                )
                            ).toUpperCase() + ' FCFA',
                            15,
                            234
                        ); //235tSize(10)
                        doc.setDrawColor(0);
                        doc.rect(14, 230, width - 28, 6);
                    }
                    doc.setFontSize(10);

                    doc.text('Visa direction:', 15, 245);
                    doc.setDrawColor(0);
                    // doc.rect(14, 246, 60, 22);
                    doc.text('Visa client:', 135, 245);
                    doc.setDrawColor(0);
                    // doc.rect(135, 246, 60, 22);
                    doc.setFontSize(8);

                    doc.setLineWidth(1.5);
                    doc.setFontSize(8);
                    doc.setLineWidth(1.5);
                    doc.setDrawColor(0, 0, 0);
                    doc.line(0, 275, width, 275);
                    doc.text(
                        'Siège social - Marcory Boulevard de Marseille - Zone 4 - 26 BP 695 Abidjan 26 - Tel.: 27 21 36 39 79 / Fax: 27 21 34 59 59',
                        105,
                        280,
                        null,
                        'center'
                    );
                    doc.text(
                        'RCCM N°CI-ABJ-2012-A-5995 - Compte SIB N° CI 007 0106885056950010020 / Cel: 07 08 29 40 40 /  Email: vicaso11@hotmail.fr ',
                        105,
                        285,
                        null,
                        'center'
                    );
                    doc.setLineWidth(0.5);
                    setLoad(false);
                    doc.setFontSize(8);
                    doc.setTextColor(254, 0, 0);
                    doc.text('* Aucun produit ne peut être retourné', 14, doc.lastAutoTable.finalY + 3);
                    // doc.text('* Aucun produit ne peut être retourner 15 jours après livraison', 14, doc.lastAutoTable.finalY + 3);

                    //doc.autoPrint({variant: 'non-conform'});
                    doc.save('bl.pdf');
                })
            )
            .catch((errors) => {
                setLoad(false);
            });
    }
    return (
        <>
            <Toast id="toast" onClose={() => setIsSave(false)} show={isSave} delay={3000} className={'bg-' + msgGravity} autohide>
                <Toast.Header>
                    <img src="holder.js/20x20?text=%20" className="rounded me-2" alt="" />
                    <strong className="me-auto">Info</strong>
                </Toast.Header>
                <Toast.Body className="dark">{msg}</Toast.Body>
            </Toast>
            {showAdd ? (
                <AddSortie
                    id={idsort}
                    setShowAdd={setShowAdd}
                    show={showAdd}
                    setIsSave={setIsSave}
                    setDatas={setDatas}
                    setMsg={setMsg}
                    setMsgravity={setMsgravity}
                    actualise={actualise}
                    setActualise={setActualise}
                    state={state}
                />
            ) : (
                <></>
            )}
            {showFilterModal ? (
                <FilterModal
                    setShowFilterModals={setShowFilterModals}
                    showFilterModal={showFilterModal}
                    setMsg={setMsg}
                    setIsSave={setIsSave}
                    setMsgravity={setMsgravity}
                    setLoad={setLoad}
                    load={load}
                    handleClose={handleClose}
                    setData={setDatas}
                    paramShow={paramShow}
                />
            ) : (
                <></>
            )}

            <div className="content contents">
                {isLoading ? <Loader /> : <></>}
                <Row>
                    <Col md="12">
                        <div id="tablecontent">
                            <Tabs id="controlled-tab-example" activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
                                <Tab eventKey="sortie" title="Mes sorties d'articles">
                                    {common.search(common.userdroit, 'SAD') !== undefined ||
                                    common.search(common.userdroit, 'SOR') !== undefined ? (
                                        <Tables
                                            rows={datas}
                                            isLoading={load}
                                            onDelete={onDelete}
                                            setIds={setIds}
                                            setIsSave={setIsSave}
                                            setMsg={setMsg}
                                            viewSortie={viewSortie}
                                            clients={client}
                                            setAdds={setAdds}
                                            printBl={printBl}
                                            setShowFilterModals={setShowFilterModals}
                                            setMsgravity={setMsgravity}
                                            setDatas={setDatas}
                                            actualise={actualise}
                                            setActualise={setActualise}
                                        />
                                    ) : (
                                        <Card style={{ width: '25rem' }} className="centerCard">
                                            <CardBody>
                                                <CardTitle tag="h5">
                                                    <TriangleHalf size={60} color="red"></TriangleHalf> Avertissement
                                                </CardTitle>
                                                <CardText>
                                                    Vous n'êtes pas autorisé à utiliser cette section. Merci de contacter votre
                                                    administrateur
                                                </CardText>
                                            </CardBody>
                                        </Card>
                                    )}
                                </Tab>
                                <Tab eventKey="proforma" title="Mes proformas">
                                    {common.search(common.userdroit, 'SAD') !== undefined ||
                                    common.search(common.userdroit, 'FAC') !== undefined ? (
                                        <IndexProforma
                                            rows={datasProf || []}
                                            keys="proforma"
                                            setIsSave={setIsSave}
                                            setMsg={setMsg}
                                            setMsgravity={setMsgravity}
                                            actualise={actualise}
                                            setActualise={setActualise}
                                            setDatasProf={setDatasProf}
                                            paramShow={paramShow}
                                            getFacture={getFacture}
                                            getProforma={getProforma}
                                            showfacture={showFacture}
                                            factureDetail={factureDetail}
                                            showDetailFactureModal={showDetailFactureModal}
                                            handleClose={handleClose}
                                            clients={client}
                                        />
                                    ) : (
                                        <Card style={{ width: '25rem' }} className="centerCard">
                                            <CardBody>
                                                <CardTitle tag="h5">
                                                    <TriangleHalf size={60} color="red"></TriangleHalf> Avertissement
                                                </CardTitle>
                                                <CardText>
                                                    Vous n'êtes pas autorisé à utiliser cette section. Merci de contacter votre
                                                    administrateur
                                                </CardText>
                                            </CardBody>
                                        </Card>
                                    )}
                                </Tab>
                                <Tab eventKey="facture" title="Mes factures">
                                    {common.search(common.userdroit, 'SAD') !== undefined ||
                                    common.search(common.userdroit, 'FAC') !== undefined ? (
                                        <IndexFacture
                                            rows={datasFact || []}
                                            keys="facture"
                                            setIsSave={setIsSave}
                                            setMsg={setMsg}
                                            setMsgravity={setMsgravity}
                                            actualise={actualise}
                                            setActualise={setActualise}
                                            setDataFact={setDataFact}
                                            paramShow={paramShow}
                                            getFacture={getFacture}
                                            getProforma={getProforma}
                                            showfacture={showFacture}
                                            factureDetail={factureDetail}
                                            showDetailFactureModal={showDetailFactureModal}
                                            handleClose={handleClose}
                                            clients={client}
                                        />
                                    ) : (
                                        <Card style={{ width: '25rem' }} className="centerCard">
                                            <CardBody>
                                                <CardTitle tag="h5">
                                                    <TriangleHalf size={60} color="red"></TriangleHalf> Avertissement
                                                </CardTitle>
                                                <CardText>
                                                    Vous n'êtes pas autorisé à utiliser cette section. Merci de contacter votre
                                                    administrateur
                                                </CardText>
                                            </CardBody>
                                        </Card>
                                    )}
                                </Tab>
                                <Tab eventKey="avoir" title="Mes avoirs">
                                    {common.search(common.userdroit, 'SAD') !== undefined ||
                                    common.search(common.userdroit, 'FAC') !== undefined ? (
                                        <IndexAvoir
                                            rows={avoirData}
                                            isLoading={load}
                                            onDelete={onDelete}
                                            setAvoirDatas={setAvoirDatas}
                                            getFactureAvoir={getFactureAvoir}
                                            keys="avoir"
                                            setIsSave={setIsSave}
                                            setMsg={setMsg}
                                            setMsgravity={setMsgravity}
                                            setLoading={setLoad}
                                            loading={load}
                                        />
                                    ) : (
                                        <Card style={{ width: '25rem' }} className="centerCard">
                                            <CardBody>
                                                <CardTitle tag="h5">
                                                    <TriangleHalf size={60} color="red"></TriangleHalf> Avertissement
                                                </CardTitle>
                                                <CardText>
                                                    Vous n'êtes pas autorisé à utiliser cette section. Merci de contacter votre
                                                    administrateur
                                                </CardText>
                                            </CardBody>
                                        </Card>
                                    )}
                                </Tab>

                                <Tab eventKey="reglement" title="Mes règlements">
                                    {common.search(common.userdroit, 'SAD') !== undefined ||
                                    common.search(common.userdroit, 'REG') !== undefined ? (
                                        <IndexReglement
                                            rows={dataReglement}
                                            isLoading={load}
                                            onDelete={onDelete}
                                            setIds={setIds}
                                            setIsSave={setIsSave}
                                            setMsg={setMsg}
                                            setAdds={setAdds}
                                            setReglementDatas={setReglementDatas}
                                            setActualise={setActualise}
                                            actualise={actualise}
                                            clients={client}
                                        />
                                    ) : (
                                        <Card style={{ width: '25rem' }} className="centerCard">
                                            <CardBody>
                                                <CardTitle tag="h5">
                                                    <TriangleHalf size={60} color="red"></TriangleHalf> Avertissement
                                                </CardTitle>
                                                <CardText>
                                                    Vous n'êtes pas autorisé à utiliser cette section. Merci de contacter votre
                                                    administrateur
                                                </CardText>
                                            </CardBody>
                                        </Card>
                                    )}
                                </Tab>
                                <Tab eventKey="article" title="Articles livrés et retournés">
                                    {common.search(common.userdroit, 'SAD') !== undefined ||
                                    common.search(common.userdroit, 'SOR') !== undefined ? (
                                        <ArticlesLivresRetournes
                                            rows={articleDatas}
                                            isLoading={load}
                                            setIsSave={setIsSave}
                                            setMsg={setMsg}
                                            setMsgravity={setMsgravity}
                                        />
                                    ) : (
                                        <Card style={{ width: '25rem' }} className="centerCard">
                                            <CardBody>
                                                <CardTitle tag="h5">
                                                    <TriangleHalf size={60} color="red"></TriangleHalf> Avertissement
                                                </CardTitle>
                                                <CardText>
                                                    Vous n'êtes pas autorisé à utiliser cette section. Merci de contacter votre
                                                    administrateur
                                                </CardText>
                                            </CardBody>
                                        </Card>
                                    )}
                                </Tab>
                                
                            </Tabs>
                        </div>
                    </Col>
                </Row>
            </div>

            <Modal show={show} size="xl">
                <Form noValidate>
                    <Modal.Header>
                        {typeModal === 1 ? "INFO SORTIE D'ARTICLE" : 'FACTURER CETTE SORTIE'}{' '}
                        <Backspace onClick={handleClose} color="red" size={30} />
                    </Modal.Header>

                    <Modal.Body>
                        <div id="lightbody">
                            <Row>
                                <Col md={6}>
                                    <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                                        <Form.Label column sm={3}>
                                            N° bon sortie:
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Form.Control
                                                type="text"
                                                placeholder="N° bon sortie"
                                                aria-describedby="inputGroupPrepend"
                                                disabled
                                                size="sm"
                                                value={state.nobon}
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                                        <Form.Label column sm={3}>
                                            Client:
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Form.Control
                                                type="text"
                                                aria-describedby="inputGroupPrepend"
                                                disabled
                                                size="sm"
                                                value={clientNom}
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                                        <Form.Label column sm={3}>
                                            Demandeur:
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Form.Control
                                                type="text"
                                                aria-describedby="inputGroupPrepend"
                                                disabled
                                                size="sm"
                                                value={state.demandeur}
                                            />
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label column sm={3}>
                                            Type remise:
                                        </Form.Label>
                                        <Col sm={9}>
                                            {state.type_remise === 0 ? ' En % sur le montant total' : ' En valeur monétaire (FCFA) '}
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label column sm={3}>
                                            Valeur remise:
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Form.Control
                                                id="remise_main"
                                                type="number"
                                                aria-describedby="inputGroupPrepend"
                                                size="sm"
                                                value={state.remise_main}
                                            />
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                                        <Form.Label column sm={3}>
                                            Date sortie:
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Form.Control
                                                type="date"
                                                placeholder="Date sortie"
                                                aria-describedby="inputGroupPrepend"
                                                disabled
                                                size="sm"
                                                value={state.datesort}
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                                        <Form.Label column sm={3}>
                                            Engin:
                                        </Form.Label>
                                        <Col sm={9}>
                                            <Form.Control
                                                type="text"
                                                placeholder="Engin"
                                                aria-describedby="inputGroupPrepend"
                                                disabled
                                                size="sm"
                                                value={state.engin}
                                            />
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label column sm={3}>
                                            Application TVA:
                                        </Form.Label>
                                        <Col sm={9}>
                                            {state.sitva == 0 ? (
                                                <Form.Check type="checkbox" label="Oui" checked disabled />
                                            ) : (
                                                <Form.Check type="checkbox" label="Non" checked disabled />
                                            )}
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <table className="table table-striped-hover table-sm">
                                <thead>
                                    <tr>
                                        <th scope="col">C. barre</th>
                                        <th scope="col">Descr. art.</th>
                                        <th scope="col">Qté init</th>
                                        <th scope="col">Qté retour</th>
                                        <th scope="col">Qté reste</th>
                                        <th scope="col">Index</th>
                                        <th scope="col">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {datal?.lignesort?.map((d, index) => {
                                        var realqt = d.pivot.quantite - d.pivot.quantiteretour;
                                        return (
                                            <tr key={index} hover="true">
                                                <td>{d.qrbarre}</td>
                                                <td>{d.pivot.descriptionart || d.descriptionart}</td>
                                                <td>{d.pivot.quantite}</td>
                                                <td>{d.pivot.quantiteretour}</td>
                                                <td>{realqt}</td>
                                                <td>{d.pivot.index_transaction}</td>
                                                <td>
                                                    {datal?.facture == null ? (
                                                        <ButtonGroup aria-label="Basic example">
                                                            {/* <Link to={`/admin/article/fiche/${d.id}`} title="Voir tous les détails de l'article"><Eye  size={20}  color='royalblue'/></Link> */}
                                                            {d.pivot.si_retour !== 1 ? (
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    overlay={
                                                                        <Tooltip id="tooltip-disabled">Retourner de l'article</Tooltip>
                                                                    }
                                                                >
                                                                    <a href="#/admin/ventes" onClick={() => retours(d.pivot, 1)}>
                                                                        <Arrow90degLeft color="green" size={20} />
                                                                    </a>
                                                                </OverlayTrigger>
                                                            ) : (
                                                                <a href="#/admin/ventes" onClick={() => retours(d.pivot, 0)}>
                                                                    <OverlayTrigger
                                                                        placement="top"
                                                                        overlay={
                                                                            <Tooltip id="tooltip-disabled">
                                                                                Annuler le retourner de l'article
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <Arrow90degRight color="green" size={20} />
                                                                    </OverlayTrigger>
                                                                </a>
                                                            )}
                                                        </ButtonGroup>
                                                    ) : (
                                                        <></>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Backspace onClick={handleClose} color="red" size={30} />
                        {typeModal === 2 ? (
                            <Button type="submit" variant="ligth">
                                <Save2Fill color="#000" size={20} /> Enregister
                            </Button>
                        ) : (
                            <></>
                        )}
                    </Modal.Footer>
                </Form>
                <Modal show={showretour} onHide={() => setShowRetour(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Retour d'article</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {annulretour === 1 ? (
                            <Form.Group as={Col} md="12" controlId={1}>
                                <InputGroup hasValidation>
                                    <InputGroup.Text id="inputGroupPrepend">Quantité à retourner:</InputGroup.Text>
                                    <Form.Control
                                        type="number"
                                        placeholder="Quantité à retourner"
                                        aria-describedby="inputGroupPrepend"
                                        required
                                        size="sm"
                                        min="1"
                                        value={qte}
                                        onChange={(e) => setQte(e.target.value)}
                                    />
                                    <Form.Control.Feedback type="invalid">Veuillez saisir la quantité article.</Form.Control.Feedback>
                                </InputGroup>
                            </Form.Group>
                        ) : (
                            <Form.Group as={Col} md="12" controlId={1}>
                                <InputGroup hasValidation>
                                    <InputGroup.Text id="inputGroupPrepend">Quantité à retourner:</InputGroup.Text>
                                    <Form.Control
                                        type="number"
                                        placeholder="Quantité à retourner"
                                        aria-describedby="inputGroupPrepend"
                                        required
                                        size="sm"
                                        disabled
                                        max={qte}
                                        min="1"
                                        value={qte}
                                        onChange={(e) => setQte(e.target.value)}
                                    />
                                    <Form.Control.Feedback type="invalid">Veuillez saisir la quantité article.</Form.Control.Feedback>
                                </InputGroup>
                            </Form.Group>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => retour()}>
                            Enregister
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Modal>
        </>
    );
}

export default Index;
